import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDoordashComponent } from './simple-icons-doordash.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDoordashComponent ],
    exports:      [ SimpleIconsDoordashComponent ],
    bootstrap:    []
})
export class SimpleIconsDoordashModule {}
